module.exports = __webpack_public_path__ + "img/icon-coupon.f3153a3d.svg";